import dateFormat from "dateformat";

const useDate = () => {
    const getDates = (startDate, endDate) => {
        const listDate = [];
        const dateMove = new Date(startDate);
        let strDate = startDate;

        while (strDate < endDate) {
            strDate = dateMove.toISOString().slice(0, 10);
            listDate.push(strDate);
            dateMove.setDate(dateMove.getDate() + 1);
        }

        return listDate;
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        return dateObj instanceof Date && !isNaN(dateObj.valueOf()) ? dateFormat(dateObj, "d/m/yyyy") : date;
    };

    return {
        getDates,
        formatDate,
    };
};

export default useDate;
